import React from 'react';
import VidaSection from '../../../components/@vida/vida-section';
import VidaHeader from '../vida-header';

const VidaComputerRequirements: React.FC = () => (
  <div className="vida-content">
    <VidaHeader>VIDA for Independent Repair</VidaHeader>
    <VidaSection title="Mandatory Specifications for VIDA Computers">
      <p>
        Volvo Cars’ Vehicle Information and Diagnostics for Aftersales (VIDA)
        application is the primary tool to support workshops globally to repair
        and service Volvo vehicles. Having proper technology infrastructure is
        critical to ensuring this tool functions properly.
      </p>
      <p>
        <strong>Processor</strong>
        <ul>
          <li>Core i5 (or equivalent) or better</li>
          <li>
            Minimum of 6 physical cores for desktops - 6 virtual core (threads)
            for laptops
          </li>
          <li>Release date after October 2017</li>
          <li>
            Minimum 2.5 GHz clock speed for desktops - 2.1 GHz for laptops
          </li>
        </ul>
      </p>
      <p>
        <strong>Memory</strong> - 16GB minimum
      </p>
      <p>
        <strong>Disk space</strong> - 512GB minimum (or 256GB plus whatever the
        required capacity for non-VIDA applications - whichever is greater). For
        example, 256GB minimum Volvo Cars’ Vehicle Information and Diagnostics
        for Aftersales (VIDA) application is the primary tool to support
        workshops globally to repair and service Volvo vehicles. Having proper
        technology infrastructure is critical to ensuring this tool functions
        properly.
      </p>
      <p>
        <strong>Disk free space</strong> - 15GB minimum of free space - If disk
        has OS and storage partitions, 5GB and 10GB respectively. If this free
        space minimum cannot be maintained on a disk size minimum noted above
        using normal disk maintenance, the disk size minimum should be increased
        by 50%.
      </p>
      <p>
        <strong>Operating system</strong>:
        <ul>
          <li>Windows 11 Pro</li>
          <li style={{ fontStyle: 'italic' }}>
            Windows Home, Education, and Server editions are not supported
          </li>
          <li>
            Windows Pro, Business, and Enterprise (not LTSC) are supported
          </li>
          <li>
            Windows 11 version should be updated to a supported version as
            defined by Windows Lifecycle Policy
          </li>
          <li style={{ fontStyle: 'italic' }}>
            Virtualized environments (Citrix, Remote Desktop) are not supported
          </li>
        </ul>
      </p>
      <p>
        <strong>File System</strong> - NTFS
      </p>
      <p>
        <strong>Connections/Features</strong> - Note that the availability of
        connections may be provided by the device itself, an adapter, or a dock
        connected to the device.
      </p>
      <p>
        <strong>Technician desktop VIDA computer:</strong>
        <ul>
          <li>
            2 Ethernet ports – 1 for wired connection to LAN and 1 for P2P
            connection to OBDII
          </li>
          <li>
            2 USB 2.0 or 3.0 Type A ports – for DiCE tool connections (USB cable
            or USB dongle)
          </li>
          <li>
            2 display ports – Can be HDMI, DisplayPort, or USB-C – to support
            dual displays
          </li>
          <li>
            2 USB ports – For a wired keyboard and mouse, if use of such wired
            devices is intended
          </li>
        </ul>
      </p>
    </VidaSection>
    <VidaSection title="Antivirus/Firewall Software">
      <p>
        <strong>
          Windows Defender is the only supported antivirus solution for VIDA
          computers.
        </strong>{' '}
        Third-party antivirus software (e.g., McAfee, Sophos){' '}
        <em>are known to block VIDA processes and updates.</em> VIDA is not
        tested with third-party Antivirus/Firewall apps, and as a result, it
        will not be supported if one is installed on a VIDA computer.
      </p>
    </VidaSection>
    <VidaSection title="Web-Based Apps">
      <p>
        On a VIDA computer, it is necessary to access web- based apps using an
        Internet browser. A modern secure browser must be used to ensure its
        security features are updated regularly. Google Chrome and Microsoft
        Edge are the only supported browsers. Web-based apps that are associated
        with VIDA are noted below:
        <ul>
          <li>
            VIDA Admin - Used to administrate users, installations, settings,
            and subscriptions for VIDA.
          </li>
        </ul>
      </p>
    </VidaSection>
    <VidaSection title="VIDA Computer Ownership and Lifecycle">
      <p>
        VIDA subscribers should have a hardware lifecycle management (HLM) plan
        in place with the following minimum parameters:
        <ul>
          <li>
            VIDA computers to be removed from service or replaced with a new
            computer that meets current specifications, essentially 4 years from
            in-service date
          </li>
        </ul>
      </p>
    </VidaSection>
    {/* language=CSS */}
    <style jsx>{`
      .vida-content {
        padding: 2rem 3rem;
        font-family: 'Volvo Novum', sans-serif;
        font-size: 14px;
        min-height: 30rem;
      }

      strong {
        font-weight: 500;
      }

      table tr td {
        padding-right: 2rem;
      }

      blockquote {
        border-left: 5px solid #ddd;
        padding-left: 1rem;
      }

      .divider {
        margin: 3rem auto;
        height: 1px;
        background-color: #eee;
        width: 80%;
      }
    `}</style>
  </div>
);

export default VidaComputerRequirements;
